module.exports = __webpack_public_path__ + "img/sign-1.cad3d891.jpg";